import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService, addOnInvalidateHandler, invalidateResource } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("CargaZE");
const crud = rpcCrudService<models.CargaZE, models.CargaZEDto>(controller);

import { Guia } from "./guia";

const otros = {
    ...crud,
    /**
     * Inicia un proceso de carga para la ZE
     * */
    IniciarCargaZE: async (idChoferZE: number): Promise<number> => await controller('IniciarCargaZE', { idChoferZE }),

    /**Finaliza una CargaZE */
    FinalizarCarga: async (idCargaZE: number): Promise<void> => await controller('FinalizarCarga', { idCargaZE }),

    /**Se encarga de cerrar todas las cargas de cierto chofer */
    CerrarCargasChofer: async (idChofer: number): Promise<void> => await controller('CerrarCargasChofer', { idChofer }),

    /**Imprime el manifiesto de guías de la cargaZE indicada */
    ObtenerManifiesto: async (parametros: models.FiltroConsultaZE): Promise<string> => await controller('ObtenerManifiesto', {}, parametros),

    /**Imprime el manifiesto de guías de la choferZE indicada */
    ObtenerManifiestoChofer: async (parametros: models.ParametrosReporteManifiestoChoferZE): Promise<string> => await controller('ObtenerManifiestoChofer', {}, parametros),

    /**Escanea y agrega un folio fisico a una CargaZE */
    EscanearFolio: async (folioFisico: string, idCargaZE: number): Promise<models.LecturaFolioFisico> => await controller('EscanearFolio', { folioFisico, idCargaZE }),

    /**Incluye un conjunto de guías en una CargaZE */
    IncluirGuiasSeleccionadas: async (idGuias: number[], idCargaZE: number): Promise<models.LecturaFolioFisico> => await controller('IncluirGuiasSeleccionadas', { idGuias: idGuias, idCargaZE: idCargaZE }),

    /**Obtiene el resumen de una CargaZE */
    ObtenerResumen: async (idCargaZE: number): Promise<models.ResumenCargaDescarga> => await controller('ObtenerResumen', { idCargaZE }),

    /**Obtiene todos los servicios pendientes de acompletar una guia en una CargaZE */
    ObtenerServiciosPendientes: async (idCargaZE: number): Promise<models.PendientesCargaDescarga> => await controller('ObtenerServiciosPendientes', { idCargaZE }),

    /**Quita de la carga/descarga un servicio incompleto */
    QuitarServicioIncompleto: async (idCargaZE: number, idServicio: number, numeroFisico: number, tipo: models.TipoFolioFisico): Promise<void> => await controller('QuitarServicioIncompleto', { idCargaZE, idServicio, numeroFisico, tipo }),

    /**Obtiene todas las guias en una CargaZE */
    ObtenerGuiasEnCargaZE: async (idCargaZE: number): Promise<models.GuiaDTO[]> => await controller('ObtenerGuiasEnCargaZE', { idCargaZE }),

    /**Quita una guia de una CargaZE */
    QuitarGuia: async (idCargaZE: number, idGuia: number): Promise<void> => await controller('QuitarGuia', { idCargaZE, idGuia }),

    /**Imprime los acuses internos de las guias incluidas en esta carga ZE */
    ObtenerAcusesInternos: async (idCargaZE: number): Promise<string> => await controller('ObtenerAcusesInternos', { idCargaZE }),

    /**Devuelve una lista con las guias en un vehículo de ZE en cierta fecha */
    GuiasEnVehiculo: async (idVehiculoZE: number, fecha: Date | string): Promise<models.GuiaDTO[]> => await controller('GuiasEnVehiculo', { idVehiculoZE, fecha }),

    /**Devuelve las guías que se encuentran en el vehículo de ze que fueron agregadas en una carga distinta a la indicada */
    GuiasEnVehiculoDistintaCarga: async (idVehiculoZE: number, idCargaZE: number): Promise<models.GuiaDTO[]> => await controller('GuiasEnVehiculoDistintaCarga', { idVehiculoZE, idCargaZE }),

    /**Devuelve los folios de las guías que se encuentran en el vehículo de ze que fueron agregadas en una carga distinta a la indicada */
    FoliosGuiasEnVehiculoDistintaCarga: async (idVehiculoZE: number, idCargaZE: number): Promise<string[]> => await controller('FoliosGuiasEnVehiculoDistintaCarga', { idVehiculoZE, idCargaZE }),

    /**Regresa el avisoo de entrega no liberada si no tiene aviso regresa null */
    ObtenerAvisoEntregasNoLiberadas: async (idChoferZE: number): Promise<models.AvisoEntregaNoLiberada> => await controller('ObtenerAvisoEntregasNoLiberadas', { idChoferZE }),
}

export const CargaZE = cacheResource({
    ...otros,
    ListCargasByUserOrChoferId: async (id:number, tipoUsuario:number ): Promise<models.CargaZEDto[]> => 
    await controller("ListCargasByUserOrChoferId",{ id ,tipoUsuario }),

}, {
        query: true,
        get: true,
        getMemo: true
    }, {
        add: true,
        delete: true,
        update: true,
        IniciarCargaZE: true,
        EscanearFolio: true,
        QuitarGuia: true,
        QuitarServicioIncompleto: true,
        IncluirGuiasSeleccionadas: true,
        FinalizarCarga: true
    })

addOnInvalidateHandler(CargaZE, () => invalidateResource(Guia)); 


// WEBPACK FOOTER //
// ./app/resources/items/cargaze.ts